/* import __COLOCATED_TEMPLATE__ from './additional-card-candidate-list.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
export const ADDITIONAL_CARD_CANDIDATE_LIST_MANUAL_ENTRY_TOKEN = 'SOMEONE_ELSE';
let AdditionalCardCandidateList = (_class = class AdditionalCardCandidateList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "SOMEONE_ELSE_SELECTION_VALUE", ADDITIONAL_CARD_CANDIDATE_LIST_MANUAL_ENTRY_TOKEN);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get buttons() {
    return [{
      rank: 'primary',
      text: this.intl.t('banking.checking.onboarding.additionalCardCandidateList.cta'),
      onClick: this.onNextButtonClick
    }];
  }
  get owners() {
    return this.args.candidates.reduce((owners, currentCandidate) => {
      if (currentCandidate.owner) {
        owners.push(currentCandidate.owner);
      }
      return owners;
    }, []);
  }
  candidateRowSelected(newSelectionValue) {
    this.args.onSelectCandidate(newSelectionValue);
  }
  onNextButtonClick() {
    const selectedAssignmentCandidate = this.args.candidates.find(({
      owner
    }) => owner?.token === this.args.selectedCandidateToken);
    this.args.onNextButtonClick(selectedAssignmentCandidate);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "candidateRowSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "candidateRowSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNextButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onNextButtonClick"), _class.prototype), _class);
export { AdditionalCardCandidateList as default };